export function currencyLabel(code, name) {
  if (!code) return "";
  if (name) return `${name} (${code})`;
  try {
    const display = new Intl.DisplayNames(["en"], { type: "currency" }).of(code);
    if (display && display !== code) return `${display} (${code})`;
  } catch {
    /* Intl unavailable */
  }
  return code;
}

function pushOption(options, seen, code, name, extra = {}) {
  if (!code || seen.has(code)) return;
  seen.add(code);
  options.push({
    value: code,
    label: currencyLabel(code, name),
    ...extra,
  });
}

/** Build Select options from Shopify Markets API response */
export function optionsFromMarkets(data) {
  const nodes = data?.markets?.nodes || [];
  const shopCode = data?.shop?.currencyCode;
  const seen = new Set();
  const options = [];

  for (const market of nodes) {
    if (market?.status && market.status !== "ACTIVE") continue;
    const base = market?.currencySettings?.baseCurrency;
    pushOption(options, seen, base?.currencyCode, base?.currencyName, {
      marketName: market.name,
      primary: !!market.primary,
    });
  }

  if (!options.length && shopCode) {
    pushOption(options, seen, shopCode, null, { primary: true });
  }

  options.sort((a, b) => {
    if (a.primary !== b.primary) return a.primary ? -1 : 1;
    return a.value.localeCompare(b.value);
  });

  return options;
}

/** Fallback: shop currency + enabled presentment currencies */
export function optionsFromShop(data) {
  const shop = data?.shop;
  const seen = new Set();
  const options = [];
  const shopCode = shop?.currencyCode;

  if (shopCode) {
    pushOption(options, seen, shopCode, null, { primary: true });
  }

  const presentment = shop?.enabledPresentmentCurrencies;
  if (Array.isArray(presentment)) {
    for (const code of presentment) {
      pushOption(options, seen, code, null, { primary: code === shopCode });
    }
  }

  options.sort((a, b) => {
    if (a.primary !== b.primary) return a.primary ? -1 : 1;
    return a.value.localeCompare(b.value);
  });

  return options;
}

export function optionsFromInstallCurrency(code) {
  const c = code || "USD";
  return [{ value: c, label: currencyLabel(c), primary: true }];
}

export function resolvePrimaryCurrency(options, fallback = "USD") {
  return options.find((o) => o.primary)?.value || options[0]?.value || fallback;
}
